<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <div class="home-title mt-4 card-title">The Welland Canal: Second Canal   <v-btn text to="/TheWellandCanal">Go Back</v-btn></div>
     
         
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row wrap>
        <v-col lg="12" sm="12">
          <v-card>
            <v-card-text class="body-1">
              <h2>Operated 1845-1886</h2>27 Stone-built Locks
              <br />45.7 m (150 feet) long by 8.1 m (26.5 feet) wide.
              <br />2.7 m (9 feet) deep
              <br />

              <p>In 1845, the Second Welland Canal opened to navigation, this time with 27 stone-built locks. The canal was also deepened to the same depth as channels further downstream on the lower St. Lawrence River in order to open navigation all the way from Lake Erie to Quebec and Montreal. In 1867, with Confederation, the Welland Canal came under the control of the federal Department of Railways and Canals. The advent of steam-powered vessels with larger iron and steel hulls in the mid-nineteenth century meant that the canal locks became too small, and it was time to consider a new canal. Steam-powered tugs were also starting to replace horses and mules in towing vessels through the canal.</p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img
              contain
             
              src="../assets/images/Image_1__Second_Canal_996_10_2_entrance_to_Welland_Canal___Port_Colborne.jpg"
            ></v-img>
             <image-viewer source="Image_1__Second_Canal_996_10_2_entrance_to_Welland_Canal___Port_Colborne.jpg"></image-viewer>
            <v-card-title>“Entrance to Welland Canal" <br/>– Port Colborne</v-card-title>
            <v-card-text class="body-1">
              This illustration from Picturesque Canada (1882) depicts a dredge and steam tug with the Grand Trunk Elevator in the background.
              Port Colborne Historical & Marine Museum 996.10.2
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img
              
           
              src="../assets/images/Image_2__Second_Canal_996_10_3_Lock_no_23_Thorold.jpg"
            ></v-img>
<image-viewer source="Image_2__Second_Canal_996_10_3_Lock_no_23_Thorold.jpg"></image-viewer>
            <v-card-title>“Lock No. 23, Thorold”</v-card-title>
            <v-card-text class="body-1">
              An artist’s depiction of the towpath along the canal from Picturesque Canada (1882).
              Port Colborne Historical & Marine Museum 996.10.3
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img
              contain
            
              src="../assets/images/Photo_1__Second_Canal_986_82_173.jpg"
            ></v-img>
<image-viewer source="Photo_1__Second_Canal_986_82_173.jpg"></image-viewer>
            <v-card-text class="body-1">
              Lock 27 of the Second Canal at Port Colborne, in the foreground are winches and gates and lots of sailing ships in the background, c. 1860
              Port Colborne Historical & Marine Museum 986.82.173
            </v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img
              contain
             
              src="../assets/images/Photo_2__Second_Canal_988_11_3.jpg"
            ></v-img>
<image-viewer source="Photo_2__Second_Canal_988_11_3.jpg"></image-viewer>
            <v-card-text class="body-1">
              Port Colborne harbour on a Sunday afternoon in 1866. Loaded vessels are waiting for the canal to open at midnight.
              Port Colborne Historical & Marine Museum 988.11.3
            </v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img
              contain
            
              src="../assets/images/Phot_3__Second_Canal_986_82_239.jpg"
            ></v-img>
<image-viewer source="Phot_3__Second_Canal_986_82_239.jpg"></image-viewer>
            <v-card-text class="body-1">
              A schooner and the tug Maggie behind the wooden lock gates of the Second Welland Canal at Port Colborne, c. 1870
              Port Colborne Historical & Marine Museum 986.82.239
            </v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img
              contain
             
              src="../assets/images/Photo_4__Second_Welland_Canal_986_82_240.jpg"
            ></v-img>
<image-viewer source="Photo_4__Second_Welland_Canal_986_82_240.jpg"></image-viewer>
            <v-card-text class="body-1">
              Sailing ships in the Second Welland Canal at Port Colborne. In the foreground is a horse and cart with driver and the Grand Trunk Elevator in the background, c.1870.
              Port Colborne Historical & Marine Museum 982.82.240
            </v-card-text>
          </v-card>
        </v-col>

           <v-col lg="4" sm="12">
          <v-card>
            <v-img
              
             
              src="../assets/images/Photo_5__Second_Canal_986_82_246.jpg"
            ></v-img>
<image-viewer source="Photo_5__Second_Canal_986_82_246.jpg"></image-viewer>
            <v-card-text class="body-1">
              The tug, Maggie, tied up close to the entrance of Lock 27 in the Second Canal with the American Hotel and other businesses on East Street, Port Colborne, c. 1870.
Port Colborne Historical & Marine Museum 982.82.246
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
export default {
  name: "SecondCanal",
  components: {},
  data() {
    return {};
  },
};
</script>

<style>
</style>